import { render, staticRenderFns } from "./TDSSelect.vue?vue&type=template&id=0855a82e&scoped=true&"
import script from "./TDSSelect.vue?vue&type=script&lang=ts&"
export * from "./TDSSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TDSSelect.vue?vue&type=style&index=0&id=0855a82e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0855a82e",
  null
  
)

export default component.exports